import { z } from 'zod';
import { placeCategorySchema } from '../../place-category';

export const placeSchema = z.object({
    documentId: z.string(),
    slug: z.string(),
    description: z.any().optional(),
    name: z.string(),
    images: z.array(z.object({
        url: z.string(),
    })).optional().nullable(),
    placeCategory: placeCategorySchema.nullable().optional(),
});
